module.exports = __webpack_public_path__ + "img/setting-kiosk.df764307.gif";